export default "__VITE_ASSET__DyF_bP5u__"